module.exports = __webpack_public_path__ + "img/Logo_Prym-Soft_pion.8947d4b0.png";